import { useNavigate } from 'react-router-dom';
import { Bell, LogOut } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  return (
    <header className="glass-header sticky top-0 z-50 px-6 md:px-12 lg:px-16 py-4" data-testid="main-header">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-8">
          <h1 className="font-heading text-2xl font-bold text-primary cursor-pointer" onClick={() => navigate('/')} data-testid="logo">
            Match My Cleaner
          </h1>

          <nav className="hidden md:flex gap-6">
            <button onClick={() => navigate('/')} className="text-text-secondary hover:text-primary font-medium transition-all duration-300" data-testid="nav-home">
              {t('nav.home', 'Home')}
            </button>
            {!user && (
              <button onClick={() => navigate('/auth')} className="text-text-secondary hover:text-primary font-medium transition-all duration-300" data-testid="nav-join-cleaner">
                {t('nav.joinAsCleaner', 'Join as Cleaner')}
              </button>
            )}
            <button onClick={() => navigate('/contact')} className="text-text-secondary hover:text-primary font-medium transition-all duration-300" data-testid="nav-contact">
              {t('nav.contact', 'Contact')}
            </button>
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher className="hidden sm:inline-flex" />
          {user ? (
            <>
              <button
                onClick={() => navigate(user.role === 'admin' ? '/dashboard/admin' : user.role === 'customer' ? '/dashboard/customer' : '/dashboard/cleaner')}
                className="text-text-secondary hover:text-primary font-medium transition-all duration-300"
                data-testid="dashboard-link"
              >
                {t('nav.dashboard', 'Dashboard')}
              </button>
              <button className="relative p-2 text-text-secondary hover:text-primary transition-all duration-300" data-testid="notifications-button">
                <Bell className="w-5 h-5" />
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 text-text-secondary hover:text-error transition-all duration-300"
                data-testid="logout-button"
                aria-label={t('nav.logout', 'Logout')}
              >
                <LogOut className="w-5 h-5" />
              </button>
            </>
          ) : (
            <button onClick={() => navigate('/auth')} className="btn-primary" data-testid="login-button">
              {t('nav.login', 'Login')}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
